module.exports = __webpack_public_path__ + "static/media/distance-learning-logo.060c6272.png";